import { useQueryClient } from '@tanstack/react-query';
import { useSession } from '../SessionProvider';
import { gotoEvent } from './gotoEvent';

export const useGotoEventFetch = () => {
  const { olSession } = useSession();
  const queryClient = useQueryClient();

  const fetchEvent = async (eventId: string) => {
    try {
      const data = await gotoEvent(olSession, eventId);
      queryClient.setQueryData(['gotoEvent', eventId], data);
      return data;
    } catch (error) {
      console.error('Error fetching event data:', error);
      throw error;
    }
  };

  return fetchEvent;
};
